// extracted by mini-css-extract-plugin
export default {"myLink":"MyButton_myLink__htW5N","myBtn":"MyButton_myBtn__2yioc"};